import React, { FC } from 'react'
import { Button, Icon } from '@wmgtech/legato'
import { useScrollTrigger } from 'shared/hooks'

import { EnvContext } from 'modulesCommon/EnvProvider'
import './ScrollToTopButton.scss'

export const ScrollToTopButton: FC = () => {
  const { status } = useScrollTrigger(0)

  const goToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  return (
    <EnvContext.Consumer>
      {
        ({ primaryColor }) => status ? null : (
          <Button
            onClick={goToTop}
            icon={<Icon name="arrow-up" prefix="fas" />}
            size="md"
            className="btn__to-top"
            colorType={primaryColor}
          />
        )
      }
    </EnvContext.Consumer>
  )
}

export default ScrollToTopButton
